// extracted by mini-css-extract-plugin
export default {"botMessageNameLabel":"BotMessage-module__botMessageNameLabel--rKpL0"};